import { JsonObject, JsonProperty } from 'json2typescript';
import { Invoice } from './invoice-model';
import { RemittanceDetailNoInvoice } from './remittance-detail-no-invoice-model';

@JsonObject('RemittanceDetail')
export class RemittanceDetail extends RemittanceDetailNoInvoice {
  @JsonProperty('invoice', Invoice, true) invoice: Invoice = undefined;
}
